import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import ShowCourseName from "../pages/showCourseName";

function MyCertificates() {
  const history = useNavigate();
  const [user] = useState(() => JSON.parse(localStorage.getItem("user")));
  const [certifiedCourses, setCertifiedCourses] = useState();

  const onClickCourseNameContainer = (createAt, courseId, certificateID, userCourseId) => {
    history("/certificate", {
      state: {
        createAt,
        courseId,
        certificateID,
        fullName: user.fullName,
        userEmail: user.email,
        userCourseId,
      },
    });
  };

  const getExpirationLabel = (expiresOn) => {
    if (!expiresOn) return "";

    const daysUntil = (new Date(expiresOn) - new Date()) / (1000 * 60 * 60 * 24);

    if (daysUntil <= 0)  return "EXPIRED";
    if (daysUntil <= 1)  return `Expires in ${Math.floor(daysUntil * 24)} hours`;
    if (daysUntil <= 60) return `Expires in ${Math.floor(daysUntil)} days`;
    return "";
  };

  useEffect(() => {
    if (!user?.email) return;

    axios
      .post("/returnCertifiedCourses", { email: user.email })
      .then((res) => setCertifiedCourses(res.data))
      .catch((err) => console.error("returnCertifiedCourses failed:", err));
  }, [user?.email]);

  useEffect(() => {
    console.log(certifiedCourses)
  }, [certifiedCourses]);
  
  return (
    <Container>
      <Certificates>
        {certifiedCourses?.map((item) => {
          const courseId = item?.courseId;
          const expiresOn = item?.expiresOn;
          const daysUntilExpiration = getExpirationLabel(expiresOn);
          const isExpired = daysUntilExpiration === "EXPIRED";

          const hasValidVersion =
            isExpired &&
            certifiedCourses.some((other) => {
              const otherCourseId = other?.courseId;
              const otherExpiresOn = other?.expiresOn;
              return (
                otherCourseId === courseId &&
                otherExpiresOn &&
                new Date(otherExpiresOn) > new Date()
              );
            });

          if (hasValidVersion) return null;

          return (
            <CourseNameContainer
              key={item.certificateID}
              onClick={
                isExpired
                  ? undefined
                  : () =>
                      onClickCourseNameContainer(
                        item.certifiedAt,
                        item.courseId,
                        item.certificateID,
                        item.id,
                      )
              }
              style={{ cursor: isExpired ? "not-allowed" : "pointer", }}
            >
              {daysUntilExpiration && ( <ExpirationDate>{daysUntilExpiration}</ExpirationDate> )}
              <CourseContentInner style={{ opacity: isExpired ? 0.4 : 1 }} >
                <ShowCourseName courseId={item.courseId}/>
              </CourseContentInner>
            </CourseNameContainer>
          );
        })}
      </Certificates>
    </Container>
  );
}

export default MyCertificates;

const Container = styled.div`
  padding: 90px 20px 20px 20px;
`;

const Certificates = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(14rem, 1fr));
  grid-gap: 2rem;
`;

const ExpirationDate = styled.div`
  position: absolute;
  top: -10px;
  right: -10px;
  z-index: 1;

  height: 30px;
  width: 140px;
  border-radius: 10px;
  border: 2px solid #adadad;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
  color: white;
  background-color: #FF6275;

  display: flex;
  align-items: center;
  justify-content: center;
`;

const CourseNameContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  border: 1px solid #adadad;
  background-color: #f2f2f2;
  border-radius: 5px;
  height: 250px;
  transition: all 0.2s ease-in-out;
  position: relative;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
  cursor: pointer;
`;
const CourseContentInner = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
